import config from '../config'
import http from '../http'
import {
  getModelDetailData as mockGetModelDetailData,
  getHomeData as mockGetHomeData,
  getModelListData as mockGetModelListData,
  getAccountingData as mockGetAccountingData,
  getEvaluationData as mockGetEvaluationData,
  getLabelData as mockGetLabelData,
  getDatabaseData as mockGetDatabaseData
} from '@/mock/carbonFootprint'

export function getModelDetailData(params) {
  if (config.useMock) {
    return mockGetModelDetailData(params)
  }
  return http.get(`${config.api}/carbon/footprint/model/${params.id || 'default'}`, { params }).then(res => res.data)
}

export function getHomeData(params) {
  if (config.useMock) {
    return mockGetHomeData(params)
  }
  return http.get(`${config.api}/carbon/footprint/home`, { params }).then(res => res.data)
}

export function getModelListData(params) {
  if (config.useMock) {
    return mockGetModelListData(params)
  }
  return http.get(`${config.api}/carbon/footprint/models`, { params }).then(res => res.data)
}

export function getAccountingData(params) {
  if (config.useMock) {
    return mockGetAccountingData(params)
  }
  return http.get(`${config.api}/carbon/footprint/accounting`, { params }).then(res => res.data)
}

export function getEvaluationData(params) {
  if (config.useMock) {
    return mockGetEvaluationData(params)
  }
  return http.get(`${config.api}/carbon/footprint/evaluation`, { params }).then(res => res.data)
}

export function getLabelData(params) {
  if (config.useMock) {
    return mockGetLabelData(params)
  }
  return http.get(`${config.api}/carbon/footprint/labels`, { params }).then(res => res.data)
}

export function getDatabaseData(params) {
  if (config.useMock) {
    return mockGetDatabaseData(params)
  }
  return http.get(`${config.api}/carbon/footprint/database`, { params }).then(res => res.data)
}
